var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424.796 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1688.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1157.637-1676.624h12.5l17.21,31.307h-10.681l-2.983-5.535H1154.22l-2.81,5.535h-10.725Zm.173,19.026h12.281l-6.227-11.762Z",
    transform: "translate(-1108.493 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2793.918-1667.5h9.6c.043,3.33,1.385,3.589,4.151,3.589h11.762c2.031,0,4.107-.216,4.107-2.638,0-2.725-1.125-2.9-13.492-2.9-14.442,0-16.085-1.73-16.085-9.426,0-5.665.519-10.033,12.626-10.033h13.405c11.07,0,12.107,3.762,12.107,9.254v.994h-9.6c0-2.291-.259-3.242-4.671-3.242h-10.638c-2.161,0-3.632.734-3.632,2.421,0,2.725,1.168,2.812,11.46,2.768,14.919-.043,18.378.866,18.378,9.99,0,8.432-2.854,9.816-15.61,9.816h-11.632c-8.735,0-12.238-1.644-12.238-8.432Z",
    transform: "translate(-2715.068 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4302.161-1676.624h34.249v7.264h-24.647v5.017h23.351v6.486h-23.351v5.017h25.21v7.524h-34.812Z",
    transform: "translate(-4180.746 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5670.352-1676.624h28.972c7.395,0,9.385,3.675,9.385,9.3v1.989c0,4.2-.952,6.659-5.363,7.7v.087c2.854.518,5.232,1.772,5.232,6.919v5.318h-9.6v-3.762c0-3.286-.952-4.367-3.935-4.367h-15.091v8.13h-9.6Zm9.6,15.394h15.868c2.6,0,3.547-1.039,3.547-3.287v-1.037c0-2.767-1.384-3.287-4.411-3.287h-15Z",
    transform: "translate(-5510.322 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7089.612-1676.624H7099l6.658,23h.088l7.957-23h8.906l7.955,23h.088l6.66-23h9.385l-10.164,31.307H7125.5l-7.309-20.669h-.088l-7.307,20.669h-11.027Z",
    transform: "translate(-6889.529 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8931.2-1676.624h12.5l17.208,31.307h-10.683l-2.981-5.535h-19.461l-2.808,5.535h-10.727Zm.172,19.026h12.281l-6.227-11.762Z",
    transform: "translate(-8662.667 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10583.334-1667.5h9.6c.043,3.33,1.383,3.589,4.151,3.589h11.76c2.031,0,4.107-.216,4.107-2.638,0-2.725-1.123-2.9-13.49-2.9-14.442,0-16.086-1.73-16.086-9.426,0-5.665.519-10.033,12.628-10.033h13.4c11.07,0,12.107,3.762,12.107,9.254v.994h-9.6c0-2.291-.259-3.242-4.669-3.242h-10.641c-2.159,0-3.629.734-3.629,2.421,0,2.725,1.168,2.812,11.457,2.768,14.919-.043,18.379.866,18.379,9.99,0,8.432-2.853,9.816-15.61,9.816h-11.631c-8.736,0-12.239-1.644-12.239-8.432Z",
    transform: "translate(-10284.649 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12091.438-1677.572c0-9.167,5.146-11.33,13.794-11.33h11.288c13.664,0,15.437,2.941,15.352,11.806h-9.6v-.866c0-2.248-1.641-2.9-4.5-2.9h-10.465c-5.059,0-6.009,2.379-6.009,6.271v3.372c0,4.541.95,6.27,5.489,6.27h10.247c4.326,0,5.624-.432,5.624-4.324h9.6v2.94c0,5.276-1.9,9.428-11.543,9.428h-15.483c-8.648,0-13.794-2.163-13.794-11.33Z",
    transform: "translate(-11750.192 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13654.609-1676.624h9.6v11.156h20.234v-11.156h9.6v31.307h-9.6v-11.849h-20.234v11.849h-9.6Z",
    transform: "translate(-13269.247 -11.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.156-1653.4v8.042L0-1645.368v-31.3H9.6v23.266Z",
    transform: "translate(0 -11.886)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04a8b897.svg";
export { ForwardRef as ReactComponent };